import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { differenceInDays, format } from "date-fns";
import React, { Component } from "react";
import { connect } from "react-redux";
import AxiosClient from "../../../Network/AxiosClient";
import { FacematchAxiosClient } from "../../../Network/FacematchAxiosClient";
import { updateLocalAction } from "../../../store/actions/localActionAction";
import csv_icn from "./../../../img/reports_card/csv_icn.svg";
import download_img from "./../../../img/reports_card/download.svg";
import xlsx_img from "./../../../img/reports_card/ic_XLS.svg";
import share_img from "./../../../img/reports_card/share.svg";
import zip_icn from "./../../../img/reports_card/zip-report.svg";
import "./../styles/report.css";

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusObj: { status: "" },
      downloading: false,
    };
  }

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();

      if (this.state.downloading)
        alert("Downloading reprot! Are you sure want to leave?");
    });
  };

  componentDidMount = () => {
    this.setupBeforeUnloadListener();
  };

  componentDidUpdate(prevProps, prevState) {
    const item = this.props.report;
    const statusObj = this.state.statusObj;
    const prevStatusObj = prevState.statusObj;
    if (statusObj.status === "Pending")
      setTimeout(() => {
        this.getReportStatus(item);
      }, 10000);
    else if (
      prevStatusObj.status !== statusObj.status &&
      statusObj.status === "Generated"
    )
      this.downloadGeneratableReport(item, statusObj.downloadUrl);
  }

  download_file = (
    startDate,
    endDate,
    api_link,
    filename,
    file_type,
    module
  ) => {
    const baseURL =
      this.props.portal === "kam"
        ? process.env.REACT_APP_KAM_API_URL
        : process.env.REACT_APP_API_URL;

    let body = {
      start_time: format(new Date(this.props.startDate), "yyyy-MM-dd"),
      //moment(this.props.startDate).format("yyyy-MM-dd"),
      end_time: format(new Date(this.props.endDate), "yyyy-MM-dd"),
      //moment(this.props.endDate).format("yyyy-MM-dd"),
      team:
        this.props.filterElement &&
        this.props.filterElement.relational &&
        this.props.filterElement.relational.team
          ? this.props.filterElement.relational.team.map((item) => item.value)
          : [],
      region:
        this.props.filterElement &&
        this.props.filterElement.relational &&
        this.props.filterElement.relational.region
          ? this.props.filterElement.relational.region.map((item) => item.value)
          : [],
      area:
        this.props.filterElement &&
        this.props.filterElement.relational &&
        this.props.filterElement.relational.area
          ? this.props.filterElement.relational.area.map((item) => item.value)
          : [],
      territory:
        this.props.filterElement &&
        this.props.filterElement.relational &&
        this.props.filterElement.relational.territory
          ? this.props.filterElement.relational.territory.map(
              (item) => item.value
            )
          : [],
      agency:
        this.props.filterElement &&
        this.props.filterElement.relational &&
        this.props.filterElement.relational.agency
          ? this.props.filterElement.relational.agency.map((item) => item.value)
          : [],
    };

    this.props.updateLocalAction({
      reports: {
        ...this.props.actions,
        [filename]: "downloading",
      },
    });

    const downloadPromise = () => {
      if (module === "facematch") {
        const { start_time: startDate, end_time: endDate, ...rest } = body;
        return FacematchAxiosClient.get(`${api_link}`, {
          params: { startDate, endDate, ...rest, appName: "nimontron" },
          responseType: "blob",
        });
      } else {
        return axios.post(
          `${baseURL}${api_link}`,
          {
            ...body,
          },

          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
            },
            responseType: "blob",
          }
        );
      }
    };

    downloadPromise()
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${filename}_${
            //moment(startDate).format("yyyy-MM-dd")
            format(new Date(startDate), "yyyy-MM-dd")
          }_${
            //moment(endDate).format("yyyy-MM-dd")
            format(new Date(endDate), "yyyy-MM-dd")
          }.${file_type}`
        );
        document.body.appendChild(link);
        link.click();
      })
      .then(() =>
        this.props.updateLocalAction({
          reports: {
            ...this.props.actions,
            [filename]: null,
          },
        })
      )
      .catch((err) => {
        alert(
          "Something went wrong ! Please contact your administrator for details. "
        );
        this.props.updateLocalAction({
          reports: {
            ...this.props.actions,
            [filename]: null,
          },
        });
      });
  };

  handleDownload = () => {
    if (this.props.report.filename !== "raw_merchant_kyc")
      this.download_file(
        this.props.startDate,
        this.props.endDate,
        this.props.report.url,
        this.props.report.filename,
        this.props.report.file_type,
        this.props.report.module
      );
    else this.generateReportFromRequest(this.props.report);
  };

  // componentDidUpdate(prevProps, prevState) {
  //   const item = online_scope_reports[1];
  //   const statusObj = this.state.generationStatusConfig[item.filename];
  //   const prevStatusObj = prevState.generationStatusConfig[item.filename];
  //   if (statusObj.status === "Pending")
  //     setTimeout(() => {
  //       this.getReportStatus(item);
  //     }, 3000);
  //   else if (
  //     prevStatusObj.status !== statusObj.status &&
  //     statusObj.status === "Downloaded"
  //   )
  //     this.downloadGeneratableReport(item, statusObj.downloadUrl);
  // }

  getReportStatus = async (item) => {
    return AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/reports/v3/get-report-generation-status?report_key=${item.statusKey}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        this.setState({
          statusObj: { ...res.data },
          downloading: res.data.status === "Pending" ? true : false,
        });

        return { ...res.data };
      })
      .catch((err) => {});
  };

  generateReportFromRequest = async (item) => {
    const statusObj = await this.getReportStatus(item);

    if (statusObj.status === "Not Found") {
      AxiosClient.post(
        `${process.env.REACT_APP_API_URL}${item.url}`,
        { start_time: "", end_time: "" },
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
        .then((res) => {
          this.getReportStatus(item);
        })
        .catch((err) => {});
    }
  };

  downloadGeneratableReport = (item, url) => {
    this.setState({ downloading: true });
    axios
      .get(
        `${url}`,

        {
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `__ALL_${item.filename}_dump.${item.file_type}`
        );
        document.body.appendChild(link);
        link.click();
      })
      .then(() => {
        this.setState({
          downloading: false,
          statusObj: { status: "" },
        });
      })
      .catch((err) => {
        this.setState({ downloading: false });
        alert(
          "Something went wrong ! Please contact your administrator for details. "
        );
      });
  };

  render() {
    const isDownloadDisabled =
      this.props.report.dateRangeLimit &&
      differenceInDays(
        new Date(this.props.endDate),
        new Date(this.props.startDate)
      ) > this.props.report.dateRangeLimit
        ? true
        : false;

    const compact = this.props.isCompactView;

    return (
      <>
        <div className={compact ? "report report-compact" : "report"}>
          <div className="heading">
            <img
              className="xlsx-icon"
              src={
                this.props.report.file_type === "csv"
                  ? csv_icn
                  : this.props.report.file_type === "zip"
                  ? zip_icn
                  : xlsx_img
              }
              alt="icon"
            />
            <div className="info">
              <div className="title">{this.props.report.name}</div>
              {this.props.report.filename === "raw_merchant_kyc" &&
                this.state.statusObj.status === "Pending" && (
                  <div className="report-status">
                    Generating report
                    <CircularProgress size={10} style={{ marginLeft: 7 }} />
                  </div>
                )}
              {this.props.report.filename === "raw_merchant_kyc" &&
                this.state.statusObj.status === "Generated" &&
                this.state.downloading && (
                  <div className="report-status">
                    Downloading report
                    <CircularProgress size={10} style={{ marginLeft: 7 }} />
                  </div>
                )}
              {this.props.report.filename !== "raw_merchant_kyc" && (
                <div>
                  {isDownloadDisabled ? (
                    <div
                      className="description"
                      style={{ fontFamily: "monospace", color: "red" }}
                    >
                      {`Date range must not exceed ${this.props.report.dateRangeLimit} day(s) for this report`}
                    </div>
                  ) : (
                    <div
                      className="description"
                      style={{ fontFamily: "monospace" }}
                    >
                      From{" "}
                      {
                        //moment(this.props.startDate).format("EEE, MMM dd")
                        format(new Date(this.props.startDate), "EEE, MMMM dd")
                      }{" "}
                      to{" "}
                      {
                        //moment(this.props.endDate).format("EEE, MMM dd")
                        format(new Date(this.props.endDate), "EEE, MMMM dd")
                      }
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="action">
            <div className="button-group">
              {!compact && (
                <button
                  onClick={() => this.handleDownload()}
                  className="share-button"
                  disabled
                >
                  <img src={share_img} alt="share" />
                  Share
                </button>
              )}

              <button
                onClick={() => this.handleDownload()}
                className="download-button"
                disabled={isDownloadDisabled || this.state.downloading}
                style={{
                  opacity:
                    isDownloadDisabled || this.state.downloading ? 0.6 : 1,
                  cursor:
                    isDownloadDisabled || this.state.downloading
                      ? "no-drop"
                      : "pointer",
                }}
              >
                <img
                  src={download_img}
                  alt="download"
                  style={{ marginRight: compact ? 5 : 0 }}
                />
                Download
              </button>
            </div>
            {((this.props.actions &&
              this.props.actions[this.props.report.filename]) ||
              this.state.downloading) && (
              <div
                className="progress"
                style={{
                  borderRadius: "0px 0px 8px 8px",
                  margin: "0px",
                }}
              >
                <div className="indeterminate"></div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  let startDate = state.calendar.reports
    ? state.calendar.reports.startDate
    : state.calendar.default.startDate;
  let endDate = state.calendar.reports
    ? state.calendar.reports.endDate
    : state.calendar.default.endDate;
  let actions = state.localAction.reports
    ? state.localAction.reports
    : state.localAction.default;
  let portal = state.auth.authToken ? state.auth.authToken.portal : "dexter";

  return { startDate, endDate, actions, portal };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateLocalAction: (action) => dispatch(updateLocalAction(action)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report);
